
// You can write more code here

/* START OF COMPILED CODE */

import BaseButton from "../core/BaseButton";
import UIButton from "../core/components/UIButton";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class BtnCharacterSelect extends BaseButton {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 88.5, y ?? 88.5);

    this.scaleX = 0.7;
    this.scaleY = 0.7;

    // btn_play_png
    const btn_play_png = scene.add.image(0, 0, "common", "btn-play.png");
    this.add(btn_play_png);

    // this (components)
    const thisUIButton = new UIButton(this);
    thisUIButton.shouldPulse = true;
    thisUIButton.pulseDelay = 0;
    thisUIButton.pulseScaleEnd = 0.8;
    thisUIButton.pulseSpeed = 1000;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
